module.exports = __webpack_public_path__ + "static/media/thinBlackSig.e116dc18.png";